import React, { memo, useEffect, useState } from "react"
import ImageCover from '../../images/star-cover.webp'
import './index.scss'

interface StarProps {
  item: WeekStar.SubRankItem
  giftUrl: string
}

function Star(props: StarProps) {
  const [info, setInfo] = useState<{
    item: WeekStar.SubRankItem,
    giftUrl: string
  }>()

  useEffect(() => {
    setInfo({
      item: props.item,
      giftUrl: props.giftUrl
    })
  }, [props.item, props.giftUrl])

  return <div className="cmp-star">
    <div className="cmp-star-avatar">
      {info?.item && <img className="cmp-star-avatar__avatar" src={info.item.avatar} />}
      <img className="cmp-star-avatar__cover" src={ImageCover} />
    </div>
    <div className="cmp-star-flag">
      {info?.giftUrl && <img className="cmp-star-flag__gift" src={info.giftUrl} />}
    </div>
  </div>
}

export default memo(Star)